import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getCategories, getProducts } from "../api";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [params] = useSearchParams();
  const category = params.get("category") || "";
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const [p, c] = await Promise.all([
          getProducts({ category, q }),
          getCategories(),
        ]);
        if (!alive) return;
        setProducts(p);
        setCategories(c);
        setError("");
      } catch (e) {
        if (alive) setError(e.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [category, q]);

  const title = q
    ? `Search: ${q}`
    : category
      ? categories.find((c) => c.slug === category)?.name || "Shop"
      : "Shop";

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>{title}</h1>
          <p>
            {q
              ? `${products.length} result${products.length === 1 ? "" : "s"}`
              : "Genuine Habesha products — order for pickup in Lilburn"}
          </p>
        </div>
      </div>

      <div className="container shop-layout">
        <aside className="shop-filters" aria-label="Categories">
          <h2>Categories</h2>
          <ul className="filter-list">
            <li>
              <Link to="/shop" className={!category && !q ? "active" : ""}>
                All
                <span className="count">
                  {categories.reduce((s, c) => s + c.product_count, 0)}
                </span>
              </Link>
            </li>
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/shop?category=${cat.slug}`}
                  className={category === cat.slug ? "active" : ""}
                >
                  {cat.name}
                  <span className="count">{cat.product_count}</span>
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        <div>
          {error && <div className="flash flash-error">{error}</div>}
          {loading ? (
            <div className="empty-state">Loading products…</div>
          ) : !products.length ? (
            <div className="empty-state">
              <h2>No products found</h2>
              <p>Try another category or search.</p>
              <Link className="btn btn-primary" to="/shop">
                Back to shop
              </Link>
            </div>
          ) : (
            <div className="product-grid">
              {products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
